import React, { useState } from "react";
import "./ProfileCard.css";
import WalletActions from "../WalletActions/WalletActions";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCopy } from "@fortawesome/free-solid-svg-icons";
function ProfileCard({ name, user_uid, last_login, image, balance }) {
  const navigate = useNavigate();

  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    if (!user_uid) return;

    await navigator.clipboard.writeText(user_uid);
    setCopied(true);

    setTimeout(() => {
      setCopied(false);
    }, 2000);
  };
  return (
    <>
      <section className="ProfileCard">
        <div className="profile-card">
          <div className="profile-header">
            <img
              src={image ? image : "https://i.pravatar.cc/100"}
              alt="profile"
              className="profile-img"
            />
            <div className="profile-info">
              <h4>{name || ""}</h4>
              <p><span>UID | {user_uid || ""} </span><FontAwesomeIcon icon={faCopy} onClick={() => handleCopy()}
              /> {copied && (
                <span
                  style={{
                    position: "fixed",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    background: "#000000b9",
                    color: "#fff",
                    padding: "8px 14px",
                    fontSize: "14px",
                    borderRadius: "6px",
                    zIndex: 9999
                  }}
                >
                  UID Copied!
                </span>
              )}</p>
              <span>Last login {last_login || ""}</span>
            </div>
          </div>
          <div className="balence_box_holder">
            <div className="balance-box">
              <div>
                <p>Total Balance</p>
                <h3>{balance || ""}</h3>
              </div>
              <button className="wallet-btn" onClick={() => navigate("/wallet")}>Enter Wallet</button>
            </div>
            <WalletActions />
          </div>
        </div>
      </section>
    </>
  );
}

export default ProfileCard;
